<template>
  <v-app>
    <v-main>
      <div style="height: 0; overflow: hidden">
        <a id="skip-nav" href="#main-content">
          Vai al contenuto della pagina.
        </a>
      </div>
      <header-emilia></header-emilia>
      <!-- <div>
         <v-img v-if="$vuetify.breakpoint.smAndDown" :src="require('./assets/header-mobile.png')" />
         <v-img v-else :src="require('./assets/header-desktop.png')" />
      </div> -->
      <router-view :key="$route.path" />
      <error-dialog></error-dialog>
      <success-dialog></success-dialog>
      <div style="height: 100px"></div>
      <footer-emilia></footer-emilia>
      <!-- <div :style="$vuetify.breakpoint.smAndDown ? 'height: 250px' : 'height: 850px'">
        <v-img v-if="$vuetify.breakpoint.smAndDown" :src="require('./assets/footer-mobile.png')" />
        <v-img v-else style="height: 100%" :src="require('./assets/footer-desktop.png')" />
       </div> -->
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),

  computed: {},
};
</script>

<style>
:root {
  --v-error-base: #c72d23 !important;
}

a {
  font-size: 18px !important;
}

* {
  font-family: "Titillium Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

h1 {
  font-weight: 600;
  font-size: 36px;
  line-height: 1.3;
  color: inherit;
}

h2 {
  font-weight: 600;
  font-size: 28px;
  line-height: 1.3;
}

h4 {
  /* height: 24px; */
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 10px !important;
}

.v-text-field__details {
  margin-bottom: 0px !important;
  /* padding-left: 0px !important; */
}
</style>
